import React from "react";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export const KindBadge = ({ kind }) => (
  <Badge className="bg-slate-100 text-slate-700 border-slate-200 uppercase text-xs hover:bg-slate-100">{kind}</Badge>
);

export const InOutBadge = ({ type }) =>
  type === "in"
    ? <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100">IN</Badge>
    : <Badge className="bg-red-100 text-red-800 border-red-200 hover:bg-red-100">OUT</Badge>;

const SHIP_CLS = {
  planned: "bg-slate-100 text-slate-700 border-slate-200",
  booked: "bg-sky-100 text-sky-800 border-sky-200",
  shipped: "bg-emerald-100 text-emerald-800 border-emerald-200",
  cancelled: "bg-red-100 text-red-700 border-red-200",
};
export const ShipStatus = ({ status }) => (
  <Badge className={`${SHIP_CLS[status] || SHIP_CLS.planned} uppercase tracking-wider text-xs hover:opacity-90`}>{status}</Badge>
);

export const ReadyBadge = ({ ready, t }) =>
  ready
    ? <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100">{t("ready")}</Badge>
    : <Badge className="bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100">{t("pending")}</Badge>;

export const Dot = ({ ok }) => (
  <span className="inline-flex">{ok ? <CheckCircle2 size={14} className="text-emerald-600" /> : <AlertTriangle size={14} className="text-red-600" />}</span>
);

export const ItemCell = ({ code, name, prefix }) => (
  <div><div className="font-mono text-xs text-slate-500">{prefix ? `${prefix} · ` : ""}{code}</div>{name}</div>
);

export const d10 = (v) => (v || "").slice(0, 10) || "-";
